import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import FormFactory from "../../../../components/FormFactory";
import EmployeeRecordsFormPresenter from "./EmployeeRecordsFormPresenter";
import Hierarchy from "../../../../components/common/Hierarchy";
import RegionTab from "../../../../components/common/RegionTab";
import ShceduleTable from "../../../HumanResource/Employees/forms/employment/tables/ScheduleTable";
import ContributionDeduction from "../../../HumanResource/Employees/forms/employment/tables/ContributionDeduction";
import AllowanceAndBeni from "../../../HumanResource/Employees/forms/employment/tables/AllowanceAndBeni";

class EmployeeRecordsForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      incentive: [],
      activeTab: null,
    };
    this.presenter = new EmployeeRecordsFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "employees";
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  scheduleChange(value) {
    this.onChange(value, "selectedSchedule");
  }
  
   getTabs = (object, isViewMode) => {

    const tabs = [
      {
        title: "Schedule",
        content: (
          <ShceduleTable
            object={object}
            disabled={isViewMode}
            object_ID={object?.id}
            scheduleChange={this.scheduleChange.bind(this)}
          />
        ),
      },
      {
        title: "Contribution and Deductions",
        content: <ContributionDeduction object={object} isViewMode={isViewMode} />,
      },
      {
        title: "Allowance and Benefits",
        content: (
          <AllowanceAndBeni
            object={object}
            object_ID={object?.id}
            isViewMode={isViewMode}
          />
        ),
      },
    ];

    return tabs;

   }

   onSubmitForm(e){
    e.preventDefault();
    this.presenter.save();
   }

  render() {
    const { object } = this.state;
    console.log("object", object);

    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    const isJobOrder = object?.employmentType?.name === "Job Order";
    const allowedFields = [
      "agency",
      "surname",
      "Firstname",
      "Middlename",
      "employmentType",
      "appointmentDate",
      isJobOrder ? "nonRegPosition" : "position",
      "twentyFourSeven",
      "designations",
      ...(isJobOrder ? ["isSubmitted", "isGraduated"] : []),
    ];
    const excludeFields = Object.keys(schema.fields).filter(
      (key) => !allowedFields.includes(key)
    );

    const isViewMode = this.props.location.pathname.includes("/view/");
    const isEditMode = this.props.location.pathname.includes("/form/");

    const editModeDisabledFields = [
      "agency",
      "surname",
      "Firstname",
      "Middlename",
      "appointmentDate",
      isJobOrder ? "nonRegPosition" : "position",
    ];
    
    const tabs = this.getTabs(object, isViewMode);
    console.log("tabs", tabs);
    console.log("object", object);
    const tabContents = tabs.map((tab) => tab.content);

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    this.onSubmitForm(e);
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson defaultValue={object} rows="15" />
                    ) : (
                      <>
                        <FormFactory
                          className="col-md-4"
                          uppercase
                          schema={schema}
                          object={object}
                          onChange={this.onChange.bind(this)}
                          onTabChange={this.handleTabChange}
                          showSections={false}
                          disabled={isViewMode}
                          disabledFields={
                            isEditMode && !isViewMode
                              ? editModeDisabledFields
                              : undefined
                          }
                          excludeFields={excludeFields}
                        />
                      </>
                    )}
                  </div>
              
                  {this.state.activeTab === "employment" && (
                    <>
                      <div className="row mt-2">
                          <Hierarchy
                            className="col-lg-4 mb-3 "
                            object={object}
                            required
                            disabled={isViewMode || isEditMode}
                            // handleObjectChange={this.handleObjectChange.bind(this)}
                          />
                      </div>
                      <div className="row">
                      <div style={{ width: "92%", margin: "auto", marginBottom: "1rem" }}>
                        <hr />
                      </div>
  
                      <RegionTab tabs={tabs} tabContents={tabContents} />
                    </div>
                    </>
                    )}
                  <div className="mt-4">
                  {!isViewMode && (
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(EmployeeRecordsForm);
